export const isOfframpBill = (billType?: string | null): boolean => {
  return billType === 'offramp';
};